import React from 'react';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import { PAGE_CONFIG } from './pageConfig';
import '@/pages/dashboard/assets/scss/page/Overlay/newDaily.scss';

const reqParams = '/overview/pcConsoleDailyV3';
const PcConsoleDailyV3 = () => {
  return (
    <>
      <CommonPageRender reqParams={reqParams} pageConfigInit={PAGE_CONFIG}/>
    </>
  );
};

export default PcConsoleDailyV3;
